document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kwo-pellets-grid]').forEach(function (root) {
    var sortSelect = root.querySelector('[data-kwo-sort-select]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      window.location.search = params.toString();
    });
  });
});
